<ng-container *transloco="let t">
    <div
        fxLayout="column"
        fxLayoutAlign="start space-around"
        class="container"
        fxFlex="940px"
        fxFlex.md="940px"
        fxFlex.sm="90%"
        fxFlex.xs="90%"
        fxFlexFill
    >
        <div fxLayout="row wrap" fxLayoutAlign="center">
            <div
                fxFlex="940px"
                fxLayout.xs="column"
                fxLayoutAlign="space-between center"
                fxFlex.xs="90%"
                fxFlex.sm="100"
            >
                <h2>{{ t("support.terms-of-use.title") }}</h2>
                <button
                    mat-raised-button
                    color="primary"
                    (click)="goBack()"
                    class="go-back"
                >
                    <mat-icon aria-hidden="false" aria-label="Go Back"
                        >arrow_back</mat-icon
                    >
                    {{ t("shared.go-back") | uppercase }}
                </button>
            </div>
            <div
                fxFlex="940px"
                fxLayout.xs="column"
                fxLayoutAlign="space-between center"
                fxFlex.xs="90%"
                fxFlex.sm="100"
            >
                <p>{{ t("support.terms-of-use.sub-title") }}</p>
            </div>
        </div>

        <mat-card appearance="outlined">
            <mat-tab-group animationDuration="0ms">
                <mat-tab>
                    <ng-template mat-tab-label>{{
                        t("support.terms-of-use.tabs.legal-notice")
                    }}</ng-template>
                    <ng-container>
                        <div class="tab-content-container">
                            <h3>
                                {{ t("support.terms-of-use.tabs.tab1.title") }}
                            </h3>
                            <mat-accordion multi="true">
                                <mat-expansion-panel
                                    (opened)="panelOpenState = true"
                                    (closed)="panelOpenState = false"
                                >
                                    <mat-expansion-panel-header
                                        class="legal-notice-expansion-header"
                                    >
                                        <mat-panel-title
                                            class="legal-notice-expansion-header-title"
                                        >
                                            {{
                                                t(
                                                    "support.terms-of-use.tabs.tab1.panels.panel1.title"
                                                )
                                            }}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                        <p
                                            [innerHTML]="
                                                t(
                                                    'support.terms-of-use.tabs.tab1.panels.panel1.p1'
                                                )
                                            "
                                        ></p>
                                    </ng-template>
                                </mat-expansion-panel>

                                <mat-expansion-panel
                                    (opened)="panelOpenState = true"
                                    (closed)="panelOpenState = false"
                                >
                                    <mat-expansion-panel-header
                                        class="legal-notice-expansion-header"
                                    >
                                        <mat-panel-title
                                            class="legal-notice-expansion-header-title"
                                        >
                                            {{
                                                t(
                                                    "support.terms-of-use.tabs.tab1.panels.panel2.title"
                                                )
                                            }}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                        <p
                                            [innerHTML]="
                                                t(
                                                    'support.terms-of-use.tabs.tab1.panels.panel2.p1'
                                                )
                                            "
                                        ></p>
                                    </ng-template>
                                </mat-expansion-panel>

                                <mat-expansion-panel
                                    (opened)="panelOpenState = true"
                                    (closed)="panelOpenState = false"
                                >
                                    <mat-expansion-panel-header
                                        class="legal-notice-expansion-header"
                                    >
                                        <mat-panel-title
                                            class="legal-notice-expansion-header-title"
                                        >
                                            {{
                                                t(
                                                    "support.terms-of-use.tabs.tab1.panels.panel3.title"
                                                )
                                            }}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                        <p
                                            [innerHTML]="
                                                t(
                                                    'support.terms-of-use.tabs.tab1.panels.panel3.p1'
                                                )
                                            "
                                        ></p>
                                    </ng-template>
                                </mat-expansion-panel>

                                <mat-expansion-panel
                                    (opened)="panelOpenState = true"
                                    (closed)="panelOpenState = false"
                                >
                                    <mat-expansion-panel-header
                                        class="legal-notice-expansion-header"
                                    >
                                        <mat-panel-title
                                            class="legal-notice-expansion-header-title"
                                        >
                                            {{
                                                t(
                                                    "support.terms-of-use.tabs.tab1.panels.panel4.title"
                                                )
                                            }}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p
                                        [innerHTML]="
                                            t(
                                                'support.terms-of-use.tabs.tab1.panels.panel4.p1'
                                            )
                                        "
                                    ></p>
                                </mat-expansion-panel>

                                <mat-expansion-panel
                                    (opened)="panelOpenState = true"
                                    (closed)="panelOpenState = false"
                                >
                                    <mat-expansion-panel-header
                                        class="legal-notice-expansion-header"
                                    >
                                        <mat-panel-title
                                            class="legal-notice-expansion-header-title"
                                        >
                                            {{
                                                t(
                                                    "support.terms-of-use.tabs.tab1.panels.panel5.title"
                                                )
                                            }}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p
                                        [innerHTML]="
                                            t(
                                                'support.terms-of-use.tabs.tab1.panels.panel5.p1'
                                            )
                                        "
                                    ></p>
                                </mat-expansion-panel>

                                <mat-expansion-panel
                                    (opened)="panelOpenState = true"
                                    (closed)="panelOpenState = false"
                                >
                                    <mat-expansion-panel-header
                                        class="legal-notice-expansion-header"
                                    >
                                        <mat-panel-title
                                            class="legal-notice-expansion-header-title"
                                        >
                                            {{
                                                t(
                                                    "support.terms-of-use.tabs.tab1.panels.panel6.title"
                                                )
                                            }}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p
                                        [innerHTML]="
                                            t(
                                                'support.terms-of-use.tabs.tab1.panels.panel6.p1'
                                            )
                                        "
                                    ></p>
                                </mat-expansion-panel>

                                <mat-expansion-panel
                                    (opened)="panelOpenState = true"
                                    (closed)="panelOpenState = false"
                                >
                                    <mat-expansion-panel-header
                                        class="legal-notice-expansion-header"
                                    >
                                        <mat-panel-title
                                            class="legal-notice-expansion-header-title"
                                        >
                                            {{
                                                t(
                                                    "support.terms-of-use.tabs.tab1.panels.panel7.title"
                                                )
                                            }}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <p
                                        [innerHTML]="
                                            t(
                                                'support.terms-of-use.tabs.tab1.panels.panel7.p1'
                                            )
                                        "
                                    ></p>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                    </ng-container>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>{{
                        t("support.terms-of-use.tabs.credits")
                    }}</ng-template>
                    <app-credits></app-credits>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </div>
</ng-container>
